import { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../RestockingState'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'src/utils/store'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import * as S from './CardList.styles'

interface CardListProps {
  idList: number
  badge: string
  pagesNotAvailable: number
  totalPages: number
  priority: string
  createdAt: string
  type: string
  orderCode: string
  destinationFc?: string
}

const CardList: React.FC<CardListProps> = ({
  idList, badge, pagesNotAvailable, totalPages, priority, createdAt, type, orderCode, destinationFc,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const { acceptsPageWithPausedStatus, currentIdList } = useSelector((state) => state.restocking)
  const dispatch = useDispatch()
  const history = useHistory()

  const closeConfirmModal = () => {
    dispatch(actions.setProperty({ property: 'acceptsPageWithPausedStatus', value: false }))
    if (acceptsPageWithPausedStatus) dispatch(actions.setProperty({ property: 'currentIdList', value: undefined }))
    setShowConfirmModal(false)
  }

  const onsubmitStartRestockingListPage = (acceptPaused?: boolean) => {
    const idListToSent = currentIdList || idList

    if (!currentIdList) {
      dispatch(actions.setProperty({ property: 'currentIdList', value: idList }))
    }

    dispatch(actions.startRestockingListPage({
      idList: idListToSent,
      badge,
      history,
      acceptPaused,
    }))

    closeConfirmModal()
  }

  useEffect(() => {
    if (acceptsPageWithPausedStatus) {
      setShowConfirmModal(true)
    }
  }, [acceptsPageWithPausedStatus])

  const destinationFcCode = destinationFc?.split(' - ')[0]
  const priorityLabel = destinationFcCode ? 'prioridade (destino)' : 'prioridade'
  const priorityValue = destinationFcCode ? `${priority} (${destinationFcCode})` : priority

  return (
    <S.Container>
      <S.Row>
        <S.Column>
          <Typography variant='caption' color='ActiveBorder'>tipo</Typography>
          <Typography>{type}</Typography>
        </S.Column>
        <S.Column>
          <Typography variant='caption' color='ActiveBorder'>
            {orderCode ? 'código pedido' : priorityLabel}
          </Typography>
          <Typography style={{ wordBreak: 'break-word' }}>{orderCode || priorityValue}</Typography>
        </S.Column>
      </S.Row>
      <S.Row>
        {orderCode && (
          <S.Column>
            <Typography variant='caption' color='ActiveBorder'>prioridade</Typography>
            <Typography>{priority}</Typography>
          </S.Column>
        )}
        <S.Column>
          <Typography variant='caption' color='ActiveBorder'>execução/total</Typography>
          <S.CounterTooltip
            title={`
            ${pagesNotAvailable} página(s) em execução, de um total de ${totalPages} página(s)
          `}
            placement='top'
            arrow
          >
            <Typography>{`${pagesNotAvailable}/${totalPages}`}</Typography>
          </S.CounterTooltip>
        </S.Column>
        <S.Column>
          <Typography variant='caption' color='ActiveBorder'>data de criação</Typography>
          <Typography>{createdAt}</Typography>
        </S.Column>
      </S.Row>
      <S.CustomButton
        title='Abrir'
        bgColor='darkBlue'
        hoverColor='darkBlueHover'
        letterColor='white'
        data-testid='open-list-test'
        onClick={() => onsubmitStartRestockingListPage()}
      />
      {
        acceptsPageWithPausedStatus && (
          <ConfirmOrRejectModal
            show={showConfirmModal}
            title='Confirmar operação'
            customizableDescription={(
              <S.ContainerDescription>
                <p>
                  ATENÇÃO: Essa página já foi iniciada. Certifique-se que você já está com os produtos coletados pelo outro operador.
                </p>
                <p>
                  Deseja prosseguir?
                </p>
              </S.ContainerDescription>
            )}
            onConfirm={() => onsubmitStartRestockingListPage(true)}
            onReject={() => onsubmitStartRestockingListPage(false)}
            onClose={closeConfirmModal}
            dataTestId='confirm-accept-paused-page-modal-test-id'
            rejectButtonText='Usar outra página'
          />
        )
      }
    </S.Container>
  )
}

export default CardList
